import _ from 'underscore';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Svg_Icons from 'root/module/svg_icon';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'workspace-member-preview',

    events: {
        'click .member-access'              : 'onEditAccess',
        'click .member-notification'        : 'onEditNotification',
        'click .member-deactivate'          : 'onDeactivate',
        'click .member-reactivate'          : 'onReactivate',
        'click .member-remove'              : 'onRemove'
    },

    dom_handlers: {
        onEditAccess: function(e) {
            if (this.model.get('is_disabled')) {
                return;
            }

            Modals.editMemberAccess(this.model);
        },

        onEditNotification: function(e) {
            if (this.model.get('is_disabled')) {
                return;
            }

            Modals.editUserNotification(this.model.get('user_id'), 'email', false);
        },

        onDeactivate: function(e) {
            if (this.model.get('is_owner')) {
                return;
            }

            Modals.deactivateMember([this.model.id]);
        },

        onReactivate: function(e) {
            Modals.reactivateMember([this.model.id]);
        },

        onRemove: function(e) {
            if (this.model.get('is_owner')) {
                return;
            }

            Modals.deleteWorkspaceMember(this.model.id);
        }
    },

    event_handlers: {
        onProjectAccessChange: function(model) {
            if (this.model.get('user_id') === model.get('user_id')) {
                this.render();
            }
        }
    },

    initialize: function() {
        this.listenTo(this.model,           'change', this.render);
        this.listenTo(Cache.project_access, 'add',    this.event_handlers.onProjectAccessChange);
        this.listenTo(Cache.project_access, 'remove', this.event_handlers.onProjectAccessChange);

        this.user = Cache.user.get(this.model.get('user_id'));
    },

    render: function() {
        var project_options = '';
        var access_total = 0;

        Cache.project.where({is_archived: false}).forEach((project_model) => {
            var has_access = false;

            if (this.model.get('role') === Constants.ADMIN) {
                has_access = true;
            } else if (Cache.project_access.where({project_id: project_model.id, user_id: this.model.get('user_id')}).length) {
                has_access = true;
            }

            if (!Cache.account.hasFeature('user_restriction')) {
                has_access = true;
            }

            if (has_access) {
                access_total++;
            }

            project_options += '<li' + (has_access ? ' class="selected"' : '') + ' data-val="' + project_model.id + '">' + project_model.escape('name') + '</li>';
        });

        var can_set_permission = !this.model.get('is_disabled');
        var can_set_notification = !this.model.get('is_disabled');

        var content =
        '<div>' +
            '<img class="user-36" src="' + this.user.getAvatar(32) + '">' +
        '</div>' +

        '<div>' +
            '<div class="member-name">' +
                this.user.escape('name') +

                (this.model.get('is_owner') ?
                '<span class="badge-primary-invert badge-small member-badge">Owner</span>' : '') +

                (this.model.get('is_disabled') ?
                '<span class="badge-secondary-invert badge-small member-badge">Deactivated</span>' : '') +
            '</div>' +
            '<div class="member-email">' +
                (this.user.get('google_signin') ?
                '<span class="tooltip" data-title="Signs in via Google">' + Svg_Icons.google + '</span>' : '') +

                (this.user.get('microsoft_signin') ?
                '<span class="tooltip" data-title="Signs in via Microsoft">' + Svg_Icons.microsoft + '</span>' : '') +

                (this.user.get('sso_signin') ?
                '<span class="tooltip" data-title="Signs in via SSO">' + Svg_Icons.sso + '</span>' : '') +

                this.user.escape('email').replace(/.deleted(.[0-9]*)?/, '') +

                ((Cache.getDefaultWorkspace().get('enforce_2fa') || this.user.get('enforce_2fa')) &&
                !this.user.get('google_signin') && !this.user.get('microsoft_signin') && !this.user.get('sso_signin') ?
                '<span class="margin-left-8 badge-small badge-secondary-invert font-weight-medium"><i class="fa-solid fa-shield-check"></i> 2FA</span>' : '') +
            '</div>' +
            '<div class="last-login">' +
                '<span>' + this.model.getRoleName() + '</span>' +
                '<span>Last login: ' + (Util.moment(this.user.get('last_login')) || 'never') + '</span>' +
            '</div>' +
        '</div>' +

        '<div class="flex-top-end">' +
            '<span class="text-info">' +
                (this.model.get('role') === Constants.ADMIN ?
                'All Projects & All Sessions' :
                access_total + ' Project' + (access_total === 1 ? '' : 's') + (this.model.hasAccess(Constants.ACCESS_SESSION_REPLAY, 0) ? ' & All Sessions' : '')) +
            '</span>' +
            (Cache.app.isAdmin() ?
            '<div class="button-dropdown margin-left-16" data-append="true">' +
                '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                '<div>' +
                    '<ul class="dropdown">' +

                        (can_set_permission ?
                        '<li class="member-access">Manage role and access</li>' : '') +

                        (can_set_notification ?
                        '<li class="member-notification">Set email notifications</li>' : '') +

                        (can_set_permission || can_set_notification ?
                        '<li class="separator"></li>' : '') +

                        (this.model.get('is_disabled') ?
                        '<li class="member-reactivate">Reactivate</li>' :
                        '<li class="member-deactivate' + (this.model.get('is_owner') ? ' disabled' : '') + '">Deactivate</li>') +

                        '<li class="separator"></li>' +

                        '<li class="member-remove' + (this.model.get('is_owner') ? ' disabled' : '') + '">Remove from workspace</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' : '') +
        '</div>';

        this.$el.html(content);

        return this;
    }
});